import React, { useState, createContext, useContext, useEffect } from 'react';
import * as AccountApi from '../../Components/Common/Apis/AccountApi';

export const AuthContext = createContext();


export const AuthContextProvider = ({ children }) => {
  const [authTokens, setAuthTokens] = useState(JSON.parse(localStorage.getItem("auth")));
  const [rolePermissions, setRolePermissions] = useState();
  const [menu, setMenu] = useState();

  const setAuthToken = (tokenData, menuData, rolePermissionData) => {

    localStorage.setItem("auth", JSON.stringify(tokenData));
    setAuthTokens(tokenData);
    setMenu(menuData);
    setRolePermissions(rolePermissionData);
  };

  useEffect(() => {
    (async () => {
      if (authTokens && authTokens.expires_in > Date.now() / 1000) {
        try {
          const permissions = await AccountApi.getLoginUserRolePermission({
            access_token: authTokens.access_token,
          });

          const grantedPermissions = [];
          permissions.forEach((item) => {
            if (item.HasPermission === "True") {
              grantedPermissions.push(item);
            }
          });
          setRolePermissions(grantedPermissions);
        } catch (err) {
          console.log("err", err);
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authTokens]);

  const chkRolePermission = (module, screen, permission) => {
    if (
      rolePermissions?.some(
        (p) =>
          p.ModuleName.toLowerCase() === module.toLowerCase() &&
          p.ScreenName.toLowerCase() === screen.toLowerCase() &&
          p.PermissionNameNewPortal.toLowerCase() === permission.toLowerCase()
      )
    ) {
      return true;
    }

    return false;
  };



  // useEffect(() => {
  //   setAuthTokens(JSON.parse(localStorage.getItem("auth")));
  // }, []);

  const memoedValue = {
    authTokens,
    setAuthTokens: setAuthToken,
    menu: menu,
    chkRolePermissions: chkRolePermission
  };

  return (
    <AuthContext.Provider value={memoedValue}>
      {children}
    </AuthContext.Provider>
  );

};


export function useAuth() {
  return useContext(AuthContext);
}